module.exports = __webpack_public_path__ + "img/6frascos.7b2f6d55.png";